import { render, staticRenderFns } from "./KortexQuickDialog.vue?vue&type=template&id=4e4a5095&scoped=true"
import script from "./KortexQuickDialog.vue?vue&type=script&lang=js"
export * from "./KortexQuickDialog.vue?vue&type=script&lang=js"
import style0 from "./KortexQuickDialog.vue?vue&type=style&index=0&id=4e4a5095&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4a5095",
  null
  
)

export default component.exports